export const HOME_ROUTE: string = '/';
export const ABOUT_ROUTE: string = '/about';
export const CONTACT_ROUTE: string = '/contact';
